import React from 'react'
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from './Media';

const LeftBanner = () => {
    const [text] = useTypewriter({
        words: ["SDET.", "Test Automation Engineer.", "Performance Test Engineer."],
        loop: true,
        typeSpeed: 20,
        deleteSpeed: 10,
        delaySpeed: 2000,
    });

    return (
        <div className="w-full lgl:w-1/2 flex flex-col gap-20">
            <div className="flex flex-col gap-5">
                <h4 className="text-lg font-normal">WELCOME TO MY WORLD</h4>

                <h1 className="text-6xl font-bold text-white">
                    I'm <span className="text-designColor capitalize">César Agudelo</span>
                </h1>

                <h2 className="text-4xl font-bold text-white">
                    a <span>{text}</span>
                    <Cursor
                        cursorBlinking="false"
                        cursorStyle="|"
                        cursorColor="#ff014f"
                    />
                </h2>

                {/* Justified description */}
                <p className="text-base font-bodyFont leading-6 tracking-wide text-justify">
                    I use automation as a strategic tool to bridge the gap between development and
                    quality. My goal isn’t just to run tests, but to engineer reliability into products.
                    I design scalable automation frameworks that catch issues early, enabling faster
                    releases without compromising stability.
                </p>
            </div>

            {/* Media */}
            <Media />
        </div>
    );
}

export default LeftBanner;